import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { trackById } from '../../shared/utility-functions/track-by-id.utility'
import { FilterOptionModel, LinkModel, SegmentedControlModel } from '@flocasts/experience-service-types'
import { isLinkModel } from 'src/app/shared/functions/type-guards'

@Component({
  selector: 'flo-segmented-control',
  templateUrl: './segmented-control.component.html',
  styles: [
    `
      a.btn {
        min-width: auto;
        white-space: nowrap;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegmentedControlComponent {
  @Input()
  segmentedControl: SegmentedControlModel

  public trackById = trackById

  @Output()
  optionClicked = new EventEmitter<FilterOptionModel>()

  handleClick(option: LinkModel | FilterOptionModel): void {
    // unselect previous option
    if (isLinkModel(option)) {
      const prevOption = (this.segmentedControl.options as LinkModel[]).find(x => x.state === 'selected')
      if (prevOption) {
        prevOption.state = 'unselected'
      }

      // select current option
      option.state = 'selected'
    } else if (!option.isSelected) {
      this.optionClicked.emit(option)
    }
  }
}
